<template>
	<tr @click="goToPair" class="[&_td]:!align-middle">
		<td>
			<TokenImage :mint="pool.mintA" class="me-2"></TokenImage>
			<TokenImage :mint="pool.mintB"></TokenImage>
		</td>
		<td><AccountAddress :address="pool.address"></AccountAddress></td>
		<td class="d-none d-md-table-cell"><AccountAddress :address="pool.mintA"></AccountAddress></td>
		<td class="d-none d-md-table-cell"><AccountAddress :address="pool.mintB"></AccountAddress></td>
<!--		<td><AccountAddress :address="pool.account.tokenPool"></AccountAddress></td>-->
		<td class="d-none d-lg-table-cell"><code>{{ curveTypeString()}}</code></td>
	</tr>
</template>

<script>
import AccountAddress from "@/components/common/AccountAddress.vue";
import TokenImage from "@/components/common/TokenImage.vue";

export default {
	name: "PoolRow",
	components: {TokenImage, AccountAddress},
	props: {
		pool: {
			type: Object,
			required: true
		}
	},
	methods: {
		curveTypeString: function() {
			switch (this.pool.curveType) {
				case 0:
					return "Constant Price";
				case 1:
					return "Stable";
				case 2:
					return "Offset";
				default:
					return "Unknown";
			}
		},
		goToPair: function() {
			this.$router.push(`/app/pools/${this.pool.address}`)
		}
	}
}
</script>

<style scoped>

</style>